/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const ArrowUpIcon = createIcon({
  displayName: "ArrowUpIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.43923 9.24989L6.76245 4.92666C7.44587 4.24325 8.55391 4.24325 9.23732 4.92666L13.5605 9.24989L12.4999 10.3105L8.17666 5.98732C8.07903 5.88969 7.92074 5.88969 7.82311 5.98732L3.49989 10.3105L2.43923 9.24989Z"
        fill="currentColor"
      />
    </g>
  )
});
